import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { fetchFullCalendarEvent } from 'owa-calendar-surface-full-event-locked-store';
import { getCalendarEventFromSurface } from 'owa-calendar-surface-surface-store';
import { isBirthdayEvent } from 'owa-calendar-event-capabilities';
import { isCalendarEventLocalLie } from 'owa-calendar-event-local-lie';
import { lazyShowItemContextMenu } from 'owa-calendar-surface-contextmenu-actions';
import { lazyInitializeLivePersonaCardForBirthdayEvent } from 'owa-event-context-menu';

/**
 * Open calendar item context menu
 */
export function openItemContextMenu(
    surfaceItem: CalendarEvent,
    clickEvent: React.MouseEvent<HTMLDivElement>
) {
    if (!isCalendarEventLocalLie(surfaceItem)) {
        fetchFullCalendarEvent(surfaceItem.ItemId, null, getCalendarEventFromSurface, undefined, {
            fetchSource: 'CalendarModuleOpenItemContextMenu',
        });

        // if this a birthday event, initialize the LivePersonaCard in background (do not await) if it is not already initialized
        if (isBirthdayEvent(surfaceItem)) {
            lazyInitializeLivePersonaCardForBirthdayEvent.importAndExecute();
        }

        lazyShowItemContextMenu.importAndExecute(
            surfaceItem.ItemId,
            surfaceItem.ParentFolderId.Id,
            clickEvent
        );
    }
}
